<template>
  <div id="LoggedIn" class="theme position-relative d-flex" ref="logged_in">
    <div class="aside" v-if="showSideBar">
      <SideNav class="position-fixed"></SideNav>
    </div>
    <div class="main float-lg-right" :class="{ 'no-side-bar': !showSideBar }">
      <b-container fluid class="px-0">
        <Navigation class="d-flex"></Navigation>
        <ContentRouter @scroll-to="scrollTo" />
        <DownloadBanner
          v-if="$store.getters.skin === 8 && $route.name !== 'download'"
        />
        <Footer v-else></Footer>
      </b-container>
    </div>
    <PodcastPlayer></PodcastPlayer>
  </div>
</template>

<script>
// @ is an alias to /src
import TopNav from "@/components/TopNav.vue";
import Navigation from "@/components/Navigation.vue";
import MobileNav from "@/components/MobileNav.vue";
import MobileNavigation from "@/components/MobileNavigation.vue";
import SideNav from "@/components/SideNav.vue";
import ContentRouter from "@/components/ContentRouter.vue";
import Footer from "@/components/Footer.vue";
import DownloadBanner from "@/components/DownloadBanner.vue";
import PodcastPlayer from "@/components/SoundSpace/PodcastPlayer.vue";
import config from "../config/constants";

export default {
  name: "LoggedIn",
  components: {
    TopNav,
    Navigation,
    MobileNav,
    MobileNavigation,
    SideNav,
    ContentRouter,
    Footer,
    DownloadBanner,
    PodcastPlayer,
  },
  data() {
    return {};
  },
  created() {
    console.log(this.$store.state.user);
    localStorage.setItem('bearerToken', this.$store.getters.user_id);
    if (!this.$store.state.user.authenticated) {
      this.$store.dispatch("logout", this.$route);
      this.$router.push("/login").catch((err) => {});
    }
  },
  mounted() {
    gtag('config', process.env.VUE_APP_GA_TRACKING_ID, {
      'user_id': this.$store.getters.user.user.user_id
    });
  },
  onActive() {},
  onIdle() {
    this.$store.dispatch("logout");
    this.$router.push("/login").catch((err) => {});
  },
  methods: {
    scrollTo(coordinates) {
      this.$refs.logged_in.parentNode.scrollTop = coordinates;
    },
    getAllowedRoutes() {
      const nav = this.$store.getters.nav;
      let accessValues = {
        wellbeing_series_access: false,
        digital_gym_access: false,
        wellbeing_studio_access: false,
        wellbeing_benefits_access: false,
        my_organisation_access: false,
        eap_access: false,
        events_access: false,
        be_calm_access: false,
        plans_access: false,
      };
      for (const [key, value] of Object.entries(accessValues)) {
        nav.forEach(function (navElement) {
          navElement.items.forEach(function (navItem) {
            //if the formatted nav values and access values match, set access value to true
            if (
              navItem.name.split(" ").join("_").toLowerCase() ===
              key.replace("_access", "")
            ) {
              accessValues[key] = true;
            }
          });
        });
      }
      return accessValues;
    },
  },
  computed: {
    theme() {
      let skin = this.$store.getters.client.skin;
      return "theme-" + skin;
    },
    showSideBar() {
      if (
        this.$store.state.accessCode ||
        this.$store.getters.subdomain.toLowerCase().includes("laya-wellbeing")
      ) {
        return false;
      } else return true;
    },
  },
  watch: {
    $store() {
      if (!this.$store.state.user.authenticated) {
        this.$router.push("login").catch((err) => {});
      }
    },
    $route() {
      this.scrollTo(0);
    },
  },
};
</script>
<style lang="less">
@import "../assets/responsiveness";

.aside {
  width: 60px;
  max-width: 60px !important;
}
.main {
  .content-container {
    max-width: 1160px;
    margin: auto;
  }
  .page-bg {
    width: 100%;
    padding-bottom: 30px;
  }
  .bg-white {
    background-color: #fff;
  }
  .bg-grey {
    background-color: #f7f7f7;
  }
  .bg-primary-dark {
    background-color: #3e1954;
  }
  .page-title {
    h2 {
      font-size: 3.8rem;
      letter-spacing: 0.7rem;
      font-family: "FilsonProBold", sans-serif;
    }
  }
  h3 {
    font-size: 2.3rem;
    font-family: "FilsonProBold", sans-serif;
    padding: 40px 0 30px 0;
  }
  h4 {
    font-family: "FilsonProBook", sans-serif;
    font-size: 1.7rem;
    margin-bottom: 30px;
  }
  .section-header {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    flex-direction: row-reverse;
    &.section-header-right {
      flex-direction: row;
      .section-header-title {
        padding-right: 0;
        padding-left: 15px;
        text-transform: capitalize;
      }
    }
    .section-header-title {
      white-space: nowrap;
      padding-right: 10px;
    }
    .section-header-divider {
      height: 1px;
      background: #cdcdcd;
      width: 100%;
      transform: translateY(5px);
    }
  }
}
.pop-up-content {
  background: #fff;
  width: 100%;
  border-radius: 25px !important;
  padding: 30px 20px;
  font-family: "FilsonProBook", sans-serif;
  font-size: 2rem;
  margin-bottom: 30px;
  text-align: center;
  z-index: 10;
  .modal-header {
    text-align: center;
    border-bottom: none;
    .modal-title {
      margin: auto;
      text-align: center;
      font-size: 3rem;
    }
  }
  .modal-footer {
    border-top: none;
    justify-content: center;
    .btn {
      border: none;
      border-radius: 60px;
      font-size: 2rem;
      line-height: 1;
      letter-spacing: 0.2rem;
      border-width: 0;
      padding: 10px 30px;
    }
  }
}
</style>
